import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap/dist/css/bootstrap-utilities.min.css';


import moment from 'moment';
import "moment/locale/zh-tw";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { MuiTheme } from './MuiTheme';
import { CssBaseline } from '@mui/material';

import { SnackbarProvider } from 'notistack';
import Program2 from './Program2';
import ModalProvider from 'mui-modal-provider';
import dayjs from 'dayjs';


type Props = {}

const Program = (props: Props) => {

  // 修正 @MUI.DatePicker 月曆上顯示的 周周周
  moment.updateLocale("zh-tw", { // zh-cn
    weekdaysShort: ["一", "二", "三", "四", "五", "六", "日"]
  });

  require('dayjs/locale/zh-tw')
  dayjs.locale('zh-tw')

  return (
    <>
      <BrowserRouter>
        <CssBaseline />
        <ThemeProvider theme={MuiTheme()}>
          <SnackbarProvider maxSnack={1}
            autoHideDuration={2200}
            // dense
            style={{ marginBottom: '4em' }}>

            <ModalProvider>
              {/* 因為 AppContext 要用到 */}
              {<Program2 />}
            </ModalProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>

    </>
  )
}

export default Program


